import { render, staticRenderFns } from "./FaQManagementEnrollment.vue?vue&type=template&id=4399a4cc&"
import script from "./FaQManagementEnrollment.vue?vue&type=script&lang=js&"
export * from "./FaQManagementEnrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports